/* eslint-disable no-use-before-define, no-plusplus, no-param-reassign */
import db from '@/plugins/dexie';
import apirecebimentoweb from '@/services/api-recebimentoweb';
import store from '@/store/index';
import dadosTabelas from './local/tabelas';
import geraData from './geradata';
import obterUltimaDataTabela from './obterUltimaDataTabela';
// import { USER_STORAGE  } from '@/constants/STORAGE'

// import enviaMovimentacaoVeiculo, { deletaMovimentacaoVeiculo } from './local/enviaMovimentacaoVeiculo';
// import enviaItemMovimentacaoVeiculo, { deletaItemMovimentacaoVeiculo } from './local/enviaItemMovimentacaoVeiculo';
// import enviaVeiculo, { deletaVeiculo } from './local/enviaVeiculo';
// import enviaEventosVeiculos, { deletaEventosVeiculos } from './local/enviaEventosVeiculos';

/* function getSessionStorage(key, defaultValue) {
    return sessionStorage.getItem(key) ?? defaultValue;
} */

export default async function atualizaLocal() {
  if (!navigator.onLine) {
    console.log('Sem conexão com a internet. Sincronização cancelada.');
    store.dispatch('atualizalocal/primeiroUpdate', false);
    return;
  }

  const tokenString = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
  if (!tokenString || tokenString === 'undefined' || tokenString === 'null') {
    console.warn('Sincronização cancelada: Token de autenticação não encontrado.');
    store.dispatch('atualizalocal/primeiroUpdate', false);
    return;
  }

  console.log('=>>>');
  store.dispatch('atualizalocal/updateProcessados', 0);
  store.dispatch('atualizalocal/updateTotal', 0);
  const info = dadosTabelas();
  const cache = store.getters['cache/arraydata'];
  let arrayDataAtualizacao;
  if (!cache.length) {
    arrayDataAtualizacao = await Promise.all(Object.entries(info).map(async ([nome, dados]) => {
      if (!db[nome]) {
        console.warn(`Tabela ${nome} não existe no Dexie`);
        return {
          tabela: dados.nomeapi || nome,
          tabelaApp: nome,
          data: '1997-01-01 13:00:00.000',
        };
      }
      const dataattFinal = await obterUltimaDataTabela(nome, dados.campoatt);
      console.log(dados.nomeapi || nome, 'data', dataattFinal);
      return {
        tabela: dados.nomeapi || nome,
        tabelaApp: nome,
        data: dataattFinal,
      };
    }));
    store.commit('cache/SET_CACHE_ARRAYDATA', arrayDataAtualizacao);
  } else {
    arrayDataAtualizacao = store.getters['cache/arraydata'];
    arrayDataAtualizacao.forEach((ar) => console.log('Tabela: ', ar.tabela, 'Data: ', ar.data));
  }
  if (arrayDataAtualizacao.every((item) => item.data && item.data.startsWith('1997-01-01'))) {
    store.dispatch('atualizalocal/primeiroUpdate', true);
    store.dispatch('cache/primeiroUpdate', true);
  }
  try {
    const retorno = await apirecebimentoweb.post('all/itemsaatualizar', arrayDataAtualizacao);
    console.log('<<<=');
    geraTotal(retorno.data);
    if (Array.isArray(retorno.data)) {
      for (const item of retorno.data) {
        geraLog(item);
        // eslint-disable-next-line no-await-in-loop
        await manipulaTabela(item, info);
      }
    }
  } catch (error) {
    console.warn('Erro ao atualizar dados locais (sem internet ou servidor offline):', error);
  } finally {
    store.dispatch('atualizalocal/primeiroUpdate', false);
    store.dispatch('cache/primeiroUpdate', false);
  }
}

// eslint-disable-next-line no-unused-vars
async function geraLog({ data, tabela }) {
  console.log(`%cTabela: ${tabela}`, 'font-weight: bold; border-top: 1px solid #fff; padding-top: 3px');
  console.log(`%c${data.length}%c itens para criação ou atualização`, data.length > 0 ? 'color: #f65' : 'color: #5cc', 'color: #fff');
}

async function atualizaItensSemDataNuvem(data, tabela, info) {
  if (!Array.isArray(data) || data.length === 0 || !info[tabela]) return;

  const campoAtt = info[tabela]?.campoatt;
  const nomeApi = info[tabela]?.nomeapi || tabela;
  if (!campoAtt || !nomeApi) return;

  const itensSemData = data.filter((item) => (!item[campoAtt] || item[campoAtt] === 'null') && item.id);
  if (itensSemData.length === 0) return;

  // console.log(`[atualizaLocal] ${itensSemData.length} item(ns) na tabela ${tabela} sem ${campoAtt}. Atualizando na nuvem via PUT...`);

  await Promise.all(itensSemData.map(async (item) => {
    const dataAgora = geraData();
    const payload = { ...item };
    delete payload.id;

    payload[campoAtt] = dataAgora;

    if (tabela === 'veiculo') {
      delete payload.veidataalteracao;
      delete payload.veidatanuvem;
      delete payload.veiidveiculonuvem;
      delete payload.veideletar;
      payload.veidataatualizacao = dataAgora;
    } else if (tabela === 'movimentacaoveiculo') {
      payload.movdataalteracao = dataAgora;
      payload.movdatanuvem = payload.movdatanuvem || dataAgora;
    } else if (tabela === 'eventosveiculos') {
      payload.evvdataalteracao = dataAgora;
      payload.evvdatanuvem = payload.evvdatanuvem || dataAgora;
    } else if (tabela === 'itemmovimentacaoveiculo') {
      payload.imvdataalteracao = dataAgora;
      payload.imvdatanuvem = payload.imvdatanuvem || dataAgora;
    } else if (tabela === 'veiculoatividade') {
      payload.veadataalteracao = dataAgora;
      payload.veadatanuvem = payload.veadatanuvem || dataAgora;
    }

    try {
      await apirecebimentoweb.put(`/${nomeApi}/${item.id}`, payload);
      item[campoAtt] = dataAgora;
      if (payload.movdataalteracao) item.movdataalteracao = payload.movdataalteracao;
      if (payload.movdatanuvem) item.movdatanuvem = payload.movdatanuvem;
      if (payload.veidataatualizacao) item.veidataatualizacao = payload.veidataatualizacao;
      if (payload.evvdataalteracao) item.evvdataalteracao = payload.evvdataalteracao;
      if (payload.evvdatanuvem) item.evvdatanuvem = payload.evvdatanuvem;
      if (payload.imvdataalteracao) item.imvdataalteracao = payload.imvdataalteracao;
      if (payload.imvdatanuvem) item.imvdatanuvem = payload.imvdatanuvem;
      if (payload.veadataalteracao) item.veadataalteracao = payload.veadataalteracao;
      if (payload.veadatanuvem) item.veadatanuvem = payload.veadatanuvem;
    } catch (err) {
      console.warn(`Erro ao atualizar ${campoAtt} na nuvem via PUT para ${nomeApi}/${item.id}:`, err?.response?.data || err.message);
    }
  }));
}

// eslint-disable-next-line no-unused-vars
async function manipulaTabela({ data, tabela }, info) {
  if (!tabela || !info[tabela] || !db[tabela] || !Array.isArray(data)) {
    console.warn(`Tabela ${tabela} inválida ou não configurada no Dexie`);
    return;
  }

  await atualizaItensSemDataNuvem(data, tabela, info);

  let idnuvem = await db[tabela].toArray();
  const idLocal = idnuvem.reduce((ids, item) => {
    const key = item[`${info[tabela].prefixo}idnuvem`];
    const value = item.id;
    ids[key] = value;
    return ids;
  }, {});

  idnuvem = idnuvem.map((item) => item[`${info[tabela].prefixo}idnuvem`]);

  await deletaLocal(idnuvem, tabela, info);

  if (!idnuvem) { idnuvem = []; }

  const novosItens = [];
  const modificacoes = [];

  const totalItems = data.length;

  let processedItems = 0;
  const progressThreshold = Math.floor(totalItems * 0.01) || 1;

  let possuiUpdates = false;
  let possuiCreates = false;

  data.forEach((item) => {
    const itemFormatado = info[tabela].model(item);
    if (idnuvem.includes(item.id) && idLocal[item.id]) {
      if (!possuiUpdates) {
        possuiUpdates = true;
        store.dispatch('atualizalocal/addAAtualizar', 1);
      }
      modificacoes.push({
        key: idLocal[item.id],
        changes: itemFormatado,
      });
    } else {
      if (!possuiCreates) {
        possuiCreates = true;
        store.dispatch('atualizalocal/addAAdicionar', 1);
      }
      novosItens.push(itemFormatado);
    }

    processedItems++;

    if (processedItems >= progressThreshold) {
      store.dispatch('atualizalocal/addProcessados', processedItems);
      processedItems = 0;
    }
  });

  if (processedItems > 0) {
    store.dispatch('atualizalocal/addProcessados', processedItems);
  }

  if (modificacoes.length > 0) {
    try {
      await db[tabela].bulkUpdate(modificacoes);

      const campoData = info[tabela]?.campoatt
        || Object.keys(modificacoes[0].changes).find((item) => item.includes('dataalteracao') || item.includes('dataatualizacao'));

      const itensComData = modificacoes
        .map((obj) => obj.changes)
        .filter((c) => c && c[campoData]);

      if (campoData && itensComData.length > 0) {
        const ultimaDataAlteracao = itensComData
          .reduce((max, cur) => (new Date(cur[campoData]) > new Date(max[campoData]) ? cur : max))[campoData];
        store.dispatch('cache/atualizaData', { data: geraData(ultimaDataAlteracao), tabela });
      }

      store.dispatch('atualizalocal/addEstaAtualizado', tabela);
      store.dispatch('cache/esvaziarCache', { tabela, att: info[tabela]?.campoatt });
    } catch (err) {
      console.error('Bulk Update Error:', err);
      store.dispatch('atualizalocal/addEstaAtualizado', { tabela, erro: err.message });
    }
  }

  if (novosItens.length > 0) {
    const idKey = `${info[tabela].prefixo}idnuvem`;
    const mapaUnicos = new Map();
    for (const item of novosItens) {
      const idVal = item[idKey] ?? item.id;
      if (idVal != null) {
        mapaUnicos.set(String(idVal), item);
      } else {
        mapaUnicos.set(Symbol('idUnico'), item);
      }
    }
    const novosItensUnicos = Array.from(mapaUnicos.values());

    try {
      await db[tabela].bulkAdd(novosItensUnicos, { allKeys: true });

      const campoData = info[tabela]?.campoatt
        || Object.keys(novosItensUnicos[0] || {}).find((item) => item.includes('dataalteracao') || item.includes('dataatualizacao'));

      const itensComData = novosItensUnicos.filter((item) => item && item[campoData]);

      if (campoData && itensComData.length > 0) {
        const ultimaDataAlteracao = itensComData
          .reduce((max, cur) => (new Date(cur[campoData]) > new Date(max[campoData]) ? cur : max))[campoData];

        store.dispatch('cache/atualizaData', { data: geraData(ultimaDataAlteracao), tabela });
      }

      store.dispatch('cache/esvaziarCache', { tabela, att: info[tabela]?.campoatt });
      store.dispatch('atualizalocal/addEstaAdicionado', tabela);
    } catch (err) {
      console.error('Bulk Add Error, tentando salvar itens individualmente:', err);
      for (const item of novosItensUnicos) {
        try {
          await db[tabela].put(item);
        } catch (e) {
          console.error(`Erro ao salvar item individual na tabela ${tabela}:`, e, item);
        }
      }
      store.dispatch('atualizalocal/addEstaAdicionado', { tabela, erro: err.message });
    }
  }
}

// ⚠️ Usar somente para testes
// eslint-disable-next-line no-unused-vars
async function manipulaTabelaComDelay({ data, tabela }, info) {
  console.log('⚠️ Atualizando em modo TESTE');

  let idnuvem = await db[tabela].toArray();
  idnuvem = idnuvem.map((item) => item[`${info[tabela].prefixo}idnuvem`]);

  await deletaLocal(idnuvem, tabela, info);

  if (!idnuvem) { idnuvem = []; }

  const novosItens = [];
  const modificacoes = [];

  const totalItems = data.length;
  let processedItems = 0;
  const progressThreshold = Math.floor(totalItems * 0.01);

  let possuiUpdates = false;
  let possuiCreates = false;

  for (let i = 0; i < totalItems; i++) {
    const item = data[i];
    const itemFormatado = info[tabela].model(item);

    if (idnuvem.includes(item.id)) {
      if (!possuiUpdates) {
        possuiUpdates = true;
        store.dispatch('atualizalocal/addAAtualizar', 1);
      }
      modificacoes.push({
        id: item.id,
        updates: itemFormatado,
      });
    } else {
      if (!possuiCreates) {
        possuiCreates = true;
        store.dispatch('atualizalocal/addAAdicionar', 1);
      }
      novosItens.push(itemFormatado);
    }

    processedItems++;

    if (processedItems >= progressThreshold) {
      store.dispatch('atualizalocal/addProcessados', progressThreshold);
      processedItems = 0;
    }

    await delay(1);
  }

  if (modificacoes.length > 0) {
    try {
      await db[tabela].bulkUpdate(modificacoes);
      store.dispatch('atualizalocal/addEstaAtualizado', tabela);
    } catch (err) {
      console.error('Bulk Update Error:', err);
      store.dispatch('atualizalocal/addEstaAtualizado', { tabela, erro: err.message });
    }
  }

  if (novosItens.length > 0) {
    try {
      await db[tabela].bulkAdd(novosItens, { allKeys: true });
      store.dispatch('atualizalocal/addEstaAdicionado', tabela);
    } catch (err) {
      console.error('Bulk Add Error:', err);
      store.dispatch('atualizalocal/addEstaAdicionado', { tabela, erro: err.message });
    }
  }
}

async function geraTotal(data) {
  let total = 0;
  if (Array.isArray(data)) {
    for (const tabela of data) {
      if (Array.isArray(tabela.data)) {
        total += tabela.data.length;
      }
    }
  }
  store.dispatch('atualizalocal/updateTotal', total);
}

// eslint-disable-next-line no-unused-vars
async function deletaLocal(idnuvemlocal, tabela, info) {
  if (!db[tabela] || !idnuvemlocal || idnuvemlocal.length === 0) return;
  const nomeApi = info[tabela]?.nomeapi || tabela;
  try {
    const response = await apirecebimentoweb.get(`${nomeApi}/idnuvem`);
    const data = response?.data;
    if (!data || !Array.isArray(data)) {
      console.warn(`Aviso: O endpoint ${nomeApi}/idnuvem não retornou um array válido. Limpeza local ignorada.`);
      return;
    }
    if (data.length === 0) {
      console.warn(`⚠️ ALERTA: ${nomeApi}/idnuvem retornou 0 registros. Para evitar exclusão acidental em massa do Dexie local, o processo foi ignorado.`);
      return;
    }
    const setIdsApi = new Set(data.map((item) => {
      if (typeof item === 'number' || typeof item === 'string') return String(item);
      return String(item.id ?? item.idnuvem ?? item);
    }));

    const deleteIds = idnuvemlocal.filter((idnuvem) => idnuvem != null && idnuvem !== '' && idnuvem !== 'null' && !setIdsApi.has(String(idnuvem)));

    if (deleteIds.length > 0) {
      console.log(`Deletar na ${tabela}:`, deleteIds, idnuvemlocal);
      const chunkSize = 500;

      for (let i = 0; i < deleteIds.length; i += chunkSize) {
        const chunk = deleteIds.slice(i, i + chunkSize);

        // eslint-disable-next-line no-await-in-loop
        await db.transaction('rw', db[tabela], async () => {
          await db[tabela]
            .where(`${info[tabela].prefixo}idnuvem`)
            .anyOf(chunk)
            .delete();
        });
      }
      store.dispatch('cache/esvaziarCache', { tabela, att: info[tabela].campoatt });
    }
  } catch (err) {
    console.warn(`Erro ao verificar exclusões para ${tabela} via ${nomeApi}/idnuvem:`, err);
  }
}

// DELAY PARA TESTES DE PERFORMANCE
function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * LOCK (Trava de processo)
 *
 * Este lock garante que apenas UM processo de envio seja executado
 * por vez no navegador, mesmo em cenários como:
 * - múltiplas abas abertas
 * - múltiplos cliques no botão de sincronização
 * - execuções automáticas simultâneas (timer, onLine, focus, etc)
 *
 * O lock é persistido no IndexedDB (Dexie), portanto:
 * - sobrevive a reload da página
 * - impede execuções paralelas entre abas
 *
 * Para evitar lock "fantasma" (de uma aba fechada/recarregada no meio de
 * um sync, antes do liberarLock() rodar), o detentor mantém um HEARTBEAT:
 * enquanto sincroniza, renova `lock.data` a cada HEARTBEAT_MS. Um lock só
 * é considerado morto se ficar sem heartbeat por mais de STALE_THRESHOLD.
 * Além disso, a aba detentora libera o lock no fechamento (pagehide), e o
 * disparo inicial pode aguardar o lock liberar (aguardarLock) em vez de
 * ser descartado silenciosamente.
 */

const HEARTBEAT_MS = 5 * 1000; // renova o lock a cada 5s enquanto sincroniza
const STALE_THRESHOLD = 15 * 1000; // lock sem heartbeat há > 15s é considerado morto
const TAB_ID = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

let heartbeatId = null;
let listenerRegistrado = false;
let souDono = false; // esta aba detém o lock atualmente?

function iniciarHeartbeat() {
  pararHeartbeat();
  heartbeatId = setInterval(async () => {
    try {
      const lock = await db.processo.get('envio');
      // Só renova enquanto esta aba ainda for a dona do lock
      if (lock?.owner === TAB_ID) {
        await db.processo.update('envio', { data: Date.now() });
      } else {
        pararHeartbeat();
      }
    } catch (err) {
      console.error('Erro no heartbeat do lock:', err);
    }
  }, HEARTBEAT_MS);
}

function pararHeartbeat() {
  if (heartbeatId) {
    clearInterval(heartbeatId);
    heartbeatId = null;
  }
}

// Libera o lock se a aba for fechada/recarregada/navegada no meio de um sync,
// evitando lock "fantasma". Registrado uma única vez por aba.
function registrarLiberacaoNoFechamento() {
  if (listenerRegistrado) return;
  listenerRegistrado = true;

  // pagehide cobre fechamento/navegação/unload (e bfcache) de forma mais
  // confiável que unload. Se o navegador for morto sem disparar o evento,
  // o backstop é o heartbeat + STALE_THRESHOLD.
  window.addEventListener('pagehide', () => {
    if (souDono) {
      souDono = false;
      db.processo.delete('envio').catch(() => {});
    }
  });
}

async function adquirirLock() {
  return db.transaction('rw', db.processo, async () => {
    const lock = await db.processo.get('envio');

    if (lock?.ativo) {
      const diff = Date.now() - new Date(lock.data).getTime();

      // Lock ainda vivo (heartbeat recente) → outro sync em andamento
      if (diff < STALE_THRESHOLD) {
        console.log('LOCK ATIVO');
        return false;
      }
      // Lock sem heartbeat (detentor morto) → continua e recria
    }

    await db.processo.put({
      key: 'envio',
      ativo: true,
      data: Date.now(),
      owner: TAB_ID,
    });

    souDono = true;
    return true;
  });
}

async function liberarLock() {
  pararHeartbeat();
  souDono = false;
  await db.processo.delete('envio');
}

export async function SetupEnvioLocal({ silent = false, aguardarLock = false } = {}) {
  if (!navigator.onLine) return false;

  registrarLiberacaoNoFechamento();

  let lockObtido = await adquirirLock();

  // Chamada sem espera (intervalo/online/troca de menu): se o lock estiver
  // ocupado, desiste em silêncio sem ligar o indicador de sincronização.
  if (!lockObtido && !aguardarLock) return false;

  // Se não for silencioso, liga o indicador de "Sincronizando"
  if (!silent) {
    store.dispatch('atualizalocal/syncStart');
  }
  try {
    // Disparo inicial (ex.: home): se o lock estiver ocupado, aguarda liberar
    // em vez de descartar silenciosamente o GET. Como TEMPO_MAX_ESPERA é maior
    // que STALE_THRESHOLD, um lock fantasma é recuperado dentro do loop; se ao
    // fim ainda estiver vivo, é outro sync legítimo em andamento e não forçamos.
    if (!lockObtido && aguardarLock) {
      const TEMPO_MAX_ESPERA = 20 * 1000;
      const INTERVALO_POLL = 500;
      const inicio = Date.now();

      while (!lockObtido && (Date.now() - inicio) < TEMPO_MAX_ESPERA) {
        await delay(INTERVALO_POLL);
        lockObtido = await adquirirLock();
      }
    }

    if (!lockObtido) return false;

    iniciarHeartbeat();
    try {
      await atualizaLocal(silent);
      // O envio de cadastros é realizado sob demanda pelo usuário (ao clicar no botão de salvar/enviar)
      // await enviaVeiculo();
      // await deletaVeiculo();
      // await enviaEventosVeiculos();
      // await deletaEventosVeiculos();
      // await enviaMovimentacaoVeiculo();
      // await deletaMovimentacaoVeiculo();
      // await enviaItemMovimentacaoVeiculo();
      // await deletaItemMovimentacaoVeiculo();
    } finally {
      await liberarLock();
    }
    return true;
  } finally {
    if (!silent) {
      store.dispatch('atualizalocal/syncEnd');
    }
  }
}
